<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  severity: String,
  label: String,
  centered: Boolean,
  removable: Boolean,
});

const visible = ref(true);

const severityClass = computed(() => {
  const severityMap = {
    success: "border-green-border bg-green-bg text-green-success",
    notify: "border-green-success bg-green-bg",
    info: "border-blue-border bg-blue-bg",
    error: "text-red-500",
    warn: "text-green-success",
  };
  return severityMap[props.severity] || "";
});
</script>

<template>
  <article v-if="visible" class="text-center">
    <div
      class="flex justify-between items-center gap-4 mb-20 px-30 py-17 border rounded-3xl text-left"
      :class="[severityClass, { 'inline-flex': centered }]">
      <slot></slot>
      <i
        v-if="removable"
        class="text-20 leading-[0] ri-close-line"
        @click="visible = false"></i>
    </div>
  </article>
</template>

<style scoped lang="scss"></style>
